import React, { JSX, useEffect, useState } from 'react';
import { LOCAL_STORAGE } from '@/shared/constants/localStorage';
import { SESSION_STORAGE } from '@/shared/constants/sessionStorage';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import SolgariLogo from '@/public/images/solgari-logo.png';
import SolgariLogoMini from '@/public/icons/solgari-logos/solgari-logo';
import { Dynamics } from '@/services/dynamics/dynamics';
import './inactive.scss';
import { ForceReload } from '@/components/ForceReload/ForceReload';

const { Paragraph } = Typography;

export const Inactive = () => {
  const cachedSessionStatus = !!localStorage.getItem(
    LOCAL_STORAGE.LS_SESSION_IS_ACTIVE,
  );
  const [sessionIsActive, setSessionIsActive] = useState(cachedSessionStatus);
  const inactiveText =
    Dynamics.getVersion() === 1 ? 'Dynamics 365' : 'Customer Service Workspace';
  const [contentMode, setContentMode] = useState<string>('default');
  const [warningContent, setWarningContent] = useState<JSX.Element>(<></>);
  const onActivateInstance = () => {
    localStorage.removeItem(LOCAL_STORAGE.LS_TAB_ID_KEY);
    localStorage.removeItem(LOCAL_STORAGE.LS_SESSION_IS_ACTIVE);
    sessionStorage.setItem(SESSION_STORAGE.LS_SKIP_START_BUTTON, 'true');
    window.location.reload();
  };

  const localStorageListener = (event: StorageEvent) => {
    const { key, newValue } = event;
    if (key === LOCAL_STORAGE.LS_SESSION_IS_ACTIVE) {
      setSessionIsActive(!!newValue);
    }
  };

  useEffect(() => {
    window.addEventListener('storage', localStorageListener);
    return () => window.removeEventListener('storage', localStorageListener);
  }, []);

  const handleWarning = (mode: string, content: JSX.Element) => {
    setContentMode(mode);
    setWarningContent(content);
  };

  const renderContent = () => {
    switch (contentMode) {
      case 'warning':
        return warningContent;
      default:
        return (
          <>
            <Paragraph className="inactive__info">
              Solgari for {inactiveText} is currently running in another browser
              tab. Please go back to the original browser tab to use Solgari or
              click the button below.
            </Paragraph>
            <Button
              disabled={sessionIsActive}
              className="start-button"
              data-testid="activate-instance-button"
              type="primary"
              onClick={onActivateInstance}
              icon={<ReloadOutlined />}
            >
              Set as default
            </Button>
            <ForceReload
              sendWarning={handleWarning}
              className="force-reload-button"
            />
          </>
        );
    }
  };

  return (
    <>
      <div className="inactive">
        <img src={SolgariLogo} alt="logo" className="inactive__logo" />
        {renderContent()}
      </div>
      <SolgariLogoMini />
    </>
  );
};
